import { render, staticRenderFns } from "./schoolInfo.vue?vue&type=template&id=6f37570e&scoped=true"
import script from "./schoolInfo.vue?vue&type=script&lang=js"
export * from "./schoolInfo.vue?vue&type=script&lang=js"
import style0 from "./schoolInfo.vue?vue&type=style&index=0&id=6f37570e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37570e",
  null
  
)

export default component.exports